<template>
  <div class="operation-zone">
    <slot />
  </div>
</template>

<style lang="scss">
.operation-zone {
  text-align: right;
  margin-top: 2px;
  padding: 20px 0;
  border-top: 1px solid #d2d2d2;
}
</style>
